import React__default from 'react';
import { IlSearchV2 as TranslatedIlSearchV2 } from '../IlSearchV2/index.js';

/* eslint-disable */
function IlDataTableV3Search(props) {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "IlDataTableV3Search"
  }, /*#__PURE__*/React__default.createElement(TranslatedIlSearchV2, {
    value: props.value,
    placeHolderText: props.placeHolderText,
    hideControls: false,
    labelText: props.placeHolderText,
    id: "il-data-table-search",
    onChange: function onChange(ev) {
      if (ev.target.value.length === 0) {
        props.onChange(ev);
        props.onSearch('');
      } else {
        props.onChange(ev);
      }
    },
    handleSearch: function handleSearch(searchValue) {
      props.onSearch(searchValue);
    }
  }));
}

export { IlDataTableV3Search as default };
